module.exports = __webpack_public_path__ + "img/action.3b5fff97.svg";